export default __webpack_public_path__ + "static/david-haintz-31ea8c1cf5f532cc2c20d50b4bdf946a.png";